<vwui-header>
  <h2 a11yPageTitleLevel="1">{{ 'PAGE_PROJECT_LINKS.title' | translate }}</h2>
</vwui-header>

@if (links(); as links) {
  <vwui-table [compactable]="false">
    <div slot="table-title">{{ 'PAGE_PROJECT_LINKS.table.header' | translate }}</div>
    <vwui-table-row>
      <vwui-table-header class="project-link-col project-link-col--title">{{ 'PAGE_PROJECT_LINKS.table.column.title' | translate }}</vwui-table-header>
      <vwui-table-header class="project-link-col project-link-col--link">{{ 'PAGE_PROJECT_LINKS.table.column.link' | translate }}</vwui-table-header>
      <vwui-table-header class="project-link-col project-link-col--actions"></vwui-table-header>
    </vwui-table-row>
    @for (link of links; track link.id) {
      <vwui-table-row>
        <vwui-table-column class="project-link-col project-link-col--title">{{ link.title }}</vwui-table-column>
        <vwui-table-column class="project-link-col project-link-col--link">
          <a class="project-link-url" [href]="link.link" target="_blank" rel="noopener noreferrer" [title]="link.link">{{ link.link }}</a>
        </vwui-table-column>
        <vwui-table-column class="project-link-col project-link-col--actions">
          <vwui-btn-icon icon="edit" [attr.aria-label]="'BUTTON.update' | translate" (click)="openUpdateModal(link)"></vwui-btn-icon>
          <vwui-btn-icon icon="vwui-trash" [attr.aria-label]="'BUTTON.delete' | translate" (click)="openDeleteModal(link)"></vwui-btn-icon>
        </vwui-table-column>
      </vwui-table-row>
    } @empty {
      <vwui-table-row>
        <vwui-table-column>{{ 'PAGE_PROJECT_LINKS.empty' | translate }}</vwui-table-column>
      </vwui-table-row>
    }
    <vwui-table-row>
      <vwui-table-column class="project-link-col project-link-col--title">
        <vwui-button class="is-secondary" (click)="openCreateModal()">
          {{ 'PAGE_PROJECT_LINKS.create_link' | translate }}
        </vwui-button>
      </vwui-table-column>
    </vwui-table-row>
  </vwui-table>
}
